import React, { Component } from 'react';
import { Input } from 'reactstrap';
import { Form, FormGroup } from 'reactstrap';
import { Label } from 'reactstrap';
import { Button } from 'reactstrap';
import Register from '../Register/Register';
import Resetpass from '../Resetpass/Resetpass';
import ReactDOM from "react-dom/client";
import axios from 'axios';
import withNavigateHook from '../../myRoutes';
//import {express} from 'express';
//import UserProfiles from './users.json';
import './Login.css';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { useNavigate } from 'react-router-dom'

class Login extends React.Component {
    constructor(props) {
        super(props);
        this.handleRegisterOpen = React.createRef();
        this.handleResetPassOpen = React.createRef();
        this.state = {
            username: '',
            password: '',
            loginStatus: 'Please login!',
            token: "",
            name: "",
            userRole: "",
            surName: "",
            shopName: "",
            userCode: "",
            emailAddress: "",
            db: "",
            register: "",
            userRole: "",
            msat: "",
            memberstatus: "",
            resetpass:"",

        };
    }
    loginText = "";

    handleUsernameChange = (e) => {
        this.setState({
            username: e.target.value,
        });
    };

    handlePasswordChange = (e) => {
        this.setState({
            password: e.target.value,
        });
    };

    openResetpass = () => {
        this.setState({ resetpass: "resetpass" });
        this.handleResetPassOpen.current.handleResetPassOpen();
    }

    openRegister = () => {
        this.setState({ register: "register" });
        this.handleRegisterOpen.current.handleRegisterOpen();
    }

    onRegisterClose = () => {
        this.setState({ register: "" });
    }
    onResetPassClose = () => {
        this.setState({ resetpass: "", resetemail:"", newpassword:"" });
    }

    componentDidMount = (e) => {


    };

    getMemberStatus = async (db, email) => {

    }

    authenticate = async (e) => {
        e.preventDefault();
        if ((this.state.register === "")&&(this.state.resetpass ==="")) {

            var found = false;
            if ((this.state.username === "") || (this.state.password === "")) {
                alert("Please provide valid inputs")
                return false;
            }
            else {
                e.preventDefault();
                this.setState({ username: this.username })
                let config = {
                    headers: { 'Accept': 'application/json' },
                    params: { "username": this.state.username, "password": this.state.password }
                }

                //const url = "http://localhost/kimvuka-php/api/getAuthUser.php";
                const url = "https://testmembership.bktsystems.com/api/getAuthUser.php";

                const response = await axios.get(url, config)
                //console.log(response.data[0]['firstname']);
                if (Array.isArray(response.data)) {
                    found = true;
                    let mconfig = {
                        headers: { 'Accept': 'application/json' },
                        params: { "businessname": response.data[0]['businessname'], "email": response.data[0].emailaddress }
                    }
                    if (response.data.length > 1) {
                        //const murl = "http://localhost/kimvuka-php/api/checkMemberStatus.php";
                        const url = "https://testmembership.bktsystems.com/api/checkMemberStatus.php";
                        const mresponse = await axios.get(url, mconfig)
                        // console.log(response.data)
                        this.props.navigate('/mygroups', {
                            state: {
                                userdata: response.data, email: response.data[0].emailaddress
                                // .businessname, email: response.data.emailaddress,
                                // firstname: response.data.firstname, userRole: response.data.role,
                                // memberstatus: mresponse.data
                            }
                        });

                    }
                    else {
                        //const murl = "http://localhost/kimvuka-php/api/checkMemberStatus.php";
                        const url = "https://testmembership.bktsystems.com/api/checkMemberStatus.php";
                        const mresponse = await axios.get(url, mconfig);
                        this.props.navigate('/menu', {
                            state: {
                                db: response.data[0]['businessname'], email: response.data[0].emailaddress,
                                firstname: response.data[0]['firstname'], userRole: response.data[0]['role'],
                                memberstatus: mresponse.data
                            }
                        });

                    }

                    this.loginText = 'found'
                }
                else {
                    this.loginText = 'Not found'
                    this.setState({
                        loginStatus: 'Login failed! Inavlid User/Pass', password: "", username: ""
                    });
                    console.log("Not allowed")
                }
            }

        }
        else {
            return false
        }

    }

    render() {
        return (
            <div className="mainDivHome" style={{ paddingTop: "22vh", border: '2px solid rgb(89, 100, 95)', borderRadius: "10px" }}>
                <div style={{ textAlign: "center", fontStyle: "italic" }}>
                    {(() => {
                        if (this.loginText === '') {
                            return (<label><h3>Kimvuka App  | {this.state.loginStatus}</h3></label>);
                        }
                        if (this.loginText === 'Not found') {
                            return (<label><h3>Kimvuka App</h3><span style={{ color: "red" }}>{this.state.loginStatus}</span></label>);
                        }
                    }
                    )()}
                </div>
                <div className="login-form" style={{paddingTop:"20px"}}>
                    <Form onSubmit={this.authenticate}>
                        <FormGroup>
                            {/* <Label for="username">Username</Label> */}
                            <Input
                                id="username"
                                name="username"
                                placeholder="Enter e-mail address"
                                onChange={this.handleUsernameChange}
                                type="email"
                                value={this.state.username}
                            />
                        </FormGroup>
                        <FormGroup>
                            {/* <Label for="password">Password</Label> */}
                            <Input
                                id="password"
                                name="password"
                                placeholder="Enter password"
                                value={this.state.password}
                                onChange={this.handlePasswordChange}
                                type="password"
                            />
                        </FormGroup>
                        <div style={{ paddingTop: "20px" }}>
                            <Button style={{ backgroundColor: "rgb(89, 100, 95)", width: "100%", fontWeight: "bold", color: "white" }} type="submit">Submit</Button>
                        </div>
                        <div style={{ paddingTop: "30px" }}>
                            <span >
                                <Button style={{ backgroundColor: "rgb(67, 129, 67)", width: "100%", color: "rgb(208, 247, 228)", border: "none", fontWeight: "bold", color: "white" }} text="Register" onClick={() => this.openRegister()}>Sign up here</Button>
                            </span>
                        </div>
                        <div style={{ paddingTop: "10px" }}>
                            <span >
                                <Button style={{ backgroundColor: "rgb(233, 230, 240)", width: "100%", border: "none", fontWeight: "bold", color: "rgb(89, 100, 95)" }} text="Reset passsword" onClick={() => this.openResetpass()}>Reset your password</Button>
                            </span>
                        </div>
                        <div>
                            <Register
                                ref={this.handleRegisterOpen}
                                onRegisterClose={this.onRegisterClose}
                            />
                            <Resetpass
                                ref={this.handleResetPassOpen}
                                onResetPassClose={this.onResetPassClose}
                            />
                        </div>
                    </Form>
                </div>
            </div>
        );
    }
}

export default withNavigateHook(Login);
